import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import Datatable from '../common/datatable'
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";

export class Low_purchase_customers extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            dataCateg: [],
            results: [],
            filter: '',
            temp: [],
        };
    }

    componentWillMount() {
        this.getDataUser();
    }

    getDataUser(){
        var user = AuthService.getCurrentUser();
        ApiService.getLowPurchaseHistoryCustomers(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        return { 
                            ID: row.id,
                            Nombres : row.fullname, 
                            Celular: row.cell_phonenumber,
                            Rol: row.role,
                            Embajador: row.ambassador,
                            Compras: row.purchase_count,
                            'Ult. Compra': row.last_purchase_date,
                        }
                    })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
                const resMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            }
            );
    }

    renderResults(length){
        return this.state.results.length === 0 
            ? 'No hay datos.'
            : <Datatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=100?length:100}
            pagination={true}
            class="-striped -highlight"
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Clientes" parent="Users" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Clientes con menos de 5 compras</h5>
                        </div>
                        <div className="card-body">
                            
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete text-left">
                                
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default Low_purchase_customers;
